'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002elang$002e$002dSystem$0024$002dStreams$0024 from "./java.lang.-System$-Streams$.js";
import * as $j_scala$002eutil$002e$002dDynamic$002dVariable from "./scala.util.-Dynamic-Variable.js";
var $p;
/** @constructor */
function $c_s_Console$() {
  this.Mr = null;
  $n_s_Console$ = this;
  this.Mr = new $j_scala$002eutil$002e$002dDynamic$002dVariable.$c_s_util_DynamicVariable($j_java$002elang$002e$002dSystem$0024$002dStreams$0024.$m_jl_System$Streams$().II);
}
export { $c_s_Console$ as $c_s_Console$ };
$p = $c_s_Console$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
}
export { $h_s_Console$ as $h_s_Console$ };
$h_s_Console$.prototype = $p;
$p.Cg = (function() {
  return this.Mr.AU;
});
var $d_s_Console$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_Console$, "scala.Console$", ({
  ru: 1,
  uI: 1
}));
export { $d_s_Console$ as $d_s_Console$ };
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$();
  }
  return $n_s_Console$;
}
export { $m_s_Console$ as $m_s_Console$ };
